import {QueryLangFilterOperator} from '../../enums/query-lang-filter-operator';
import {FilterCriterion} from '../../models/filters/filter-criterion';
import {QueryLangFilterCriterion} from '../../models/filters/query-lang-filter-criterion';
import {SecurityKey} from '../../models/security-key';

export const SECURITY_SYMBOL_FILTER_FIELD_NAMES: [keyof SecurityKey] = ['symbol'];
export const SECURITY_EXCHANGE_FILTER_FIELD_NAMES: [keyof SecurityKey] = ['securityExchange'];
export const SECURITY_CURRENCY_FILTER_FIELD_NAMES: [keyof SecurityKey] = ['currency'];

export const getSecurityKeyFromFilterCriteria = (filterCriteria: FilterCriterion[]): SecurityKey | undefined => {
    let result: SecurityKey | undefined = {} as SecurityKey;

    const SECURITY_KEY_FIELD_NAMES: Array<[keyof SecurityKey]> = [
        SECURITY_SYMBOL_FILTER_FIELD_NAMES,
        SECURITY_EXCHANGE_FILTER_FIELD_NAMES,
        SECURITY_CURRENCY_FILTER_FIELD_NAMES
    ];

    for (const securityKeyFieldNames of SECURITY_KEY_FIELD_NAMES) {
        const filterCriterion = filterCriteria.find(itFilterCriterion =>
            isFilterCriterionEqBy(itFilterCriterion, securityKeyFieldNames)
        );

        if (filterCriterion) {
            result[securityKeyFieldNames[0]] = filterCriterion.query;
        } else {
            result = undefined;
            break;
        }
    }

    return result;
};

export const isFilterCriterionEqBy = (
    filterCriterion: FilterCriterion,
    fieldNames: [keyof SecurityKey]
): filterCriterion is QueryLangFilterCriterion => {
    return !!filterCriterion
        && filterCriterion instanceof QueryLangFilterCriterion
        && filterCriterion.fieldNames.length === 1
        && filterCriterion.fieldNames[0] === fieldNames[0]
        && filterCriterion.operator === QueryLangFilterOperator.EQ;
};
